import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'

// import eltAndVetLogo from '../../assets/img/elt-and-vet-option.jpg'
// import eltLogo from '../../assets/img/elt-option.jpg'
// import vetLogo from '../../assets/img/vet-option.jpg'

import eltImg from '../../assets/img/elt.png'
import vetImg from '../../assets/img/vet.png'
import eltVet from '../../assets/img/firstImage.png'
import ececImg from '../../assets/img/ecec.png'

import './Register.css'
import { Item } from 'semantic-ui-react'
import FormDropdown from "../../Components/FormField/FormDropdown";

import SignupContainer from '../Signup-Login/SignupContainer'
import LinkToCreateAccount from '../Signup-Login/LinkToCreateAccount'
import CheckableButton from '../../Components/CheckableButton/CheckableButton'
import ConfirmButton from "../../Components/Buttons/ConfirmButton"
import { notify } from 'react-notify-toast'
import { Country, State }  from 'country-state-city';
import { API } from '../../API'
import Modal from '../../Components/Modal/Modal'

const countries = Country.getAllCountries();

const TeacherOption = (props) => {
  const [isAcceptTerm, setAcceptTerm] = useState(false)
  const [option, setOption] = useState(0)
  const [country, setCountry] = useState("")
  const [step, setStep] = useState(1)
  const [state, setState] = useState("")
  const [states, setStates] = useState([])
  const [cities, setcities] = useState([])
  const [city, setcity] = useState([])
  const [countryList,setcountryList] = useState({})
  const [showTeacherModal, setShowTeacherModal] = useState(false)
  const isShowECECTeacherModal = window.localStorage.getItem('isShowECECTeacherModal')

  const termChangeSelect = (e) => {
    setAcceptTerm(e.target.checked)
  }

  const getCountries = async () => {
    try{
      const list = await API.getCountriesV2();
      setcountryList(list.data.data)
    }catch(err){console.log('getCountries Err:',err)}
  }
  useEffect(() => {
    window.localStorage.setItem('userType', 'teacherLogin')
    getCountries()
    
    // Show teacher work modal every time they visit this page
    setShowTeacherModal(true);
  }, [])

  const buildOptionItem = (imageSrc, headerContent, optionIdx, disabled = false) => {
    return (
      <Item
        className={
          disabled 
            ? 'register-option-teacher-item isDisabled' 
            : (option === optionIdx) 
              ? 'register-option-teacher-item-slectioned' 
              : 'register-option-teacher-item'
        }
        onClick={disabled ? undefined : () => setOption(optionIdx)}
      >
        <div className='link-to-register'>
          <Item.Image
            size='tiny'
            src={imageSrc}
            className='register-option-img'
          />
          <Item.Content className='register-option-item-content'>
            <Item.Header>{headerContent}</Item.Header>
          </Item.Content>
        </div>
      </Item>
    )
  }

  const gotoRegPage = () => {
    window.localStorage.setItem('userType', "teacherLogin")
    if (isAcceptTerm) {
      if (option === 0) {
        notify.show('Please specify the type of account you want to create')
      } else if(country === "") { 
        notify.show('Please specify the country you want to create')
      } else if(state === "") {
        notify.show('Please specify the state you want to create')
      }
      else {
        const path = {
          pathname: "/Register",
          state: {
            is_elt: option === 1 || option === 3,
            is_vet: option === 2 || option === 3,
            is_childhood_teacher: option === 4,
            preferred_country1: country,
            state: state,
            city: city
          },
        }
        props.history.push(path)
      }
    } else {
      notify.show('Please confirm your qualification by checking the declaration before continue.')
    }
  }

  const onSelectCountry = (country) => {
    setCountry(country)
    // const states = State.getStatesOfCountry(country);
    const cities = countryList[country];
    setcities(cities)
  }

  const onsetcity = (city) => {
    setcity(city)
    let state = 'VIC'
    switch (city) {
      case 'Melbourne':
        state = 'VIC'
        break;
      case 'Sydney':
        state = 'NSW'
        break;
      case 'Brisbane':
        state = 'QLD'
        break;
      case 'Perth':
        state = 'WA'
        break;
      case 'Gold Coast':
        state = 'QLD'
        break;
      case 'Adelaide':
        state = 'SA'
        break;
      default:
        state = ' '
        break;
    }
    setState(state)
  }

  const nextStep = () => {
    if (option === 0) {
      notify.show('Please specify the type of account you want to create')
      return
    }
    setStep(prevStep => prevStep + 1)
  }

  return (
    <SignupContainer
      heading={ option === 4 ? "EDUCATOR SIGNUP" : "TEACHER SIGNUP" }
    >
      {
        step === 2 && (
          <>
            <div className='vice-tittle-for-register-option text-center my-3 mt-5'>
              Please start by selecting your main work location
            </div>
            <div className='row'>
                <FormDropdown
                  label="Select Country"
                  id="preferred_country1"
                  className="col-md-6 px-0 px-md-3"
                  required
                  value={country}
                  onChange={e => onSelectCountry(e.target.value)}
                >
                  <option value="">Please Choose</option>
                  {/* {countries.map((country) => {
                    return <option value={country.isoCode}> {country.name} </option>;
                  })} */}
                  {countryList ? Object.keys(countryList).map((country, index) => (
                    <option key={index} value={country}>{country}</option>
                  )) : null}
                </FormDropdown>

                <FormDropdown
                  label="Select City"
                  id="state"
                  className="col-md-6 px-0 px-md-3"
                  required
                  value={city}
                  // value={state}
                  onChange={e => onsetcity(e.target.value)}
                  // onChange={e => setState(e.target.value)}
                >
                  <option value="" hidden>Please Choose</option>
                  {cities.map((state) => {
                    return <option value={state}>{state}</option>;
                  })}
                  {/* {states.map((state) => {
                    return <option value={state.isoCode}>{state.name}</option>;
                  })} */}
                </FormDropdown>
            </div>
            <br />
            <div >
              <CheckableButton className="check-box-declare" checkbox noBorder onChange={termChangeSelect}>
                <span>
                  I declare that I am a qualified Teacher who complies with government regulations for Teachers in my country of residence, or that I am enrolled in a certified training program for teachers and I have legal working rights in Australia and/or New Zealand
                </span>
              </CheckableButton>
            </div>
          </>
        )
      }

      {
        step === 1 && (
          <>
            <div className='row justify-content-center mt-4'>
              <div className='vice-tittle-for-register-option'>
                Which of these best describes you?
              </div>
              <div className='my-1 text-center'>
                A Profile template will load that best reflects your selection. This
                template selection cannot be reversed
              </div>
            </div>
            <div className='row justify-content-center register-option-content'>


              <Item.Group>
                {/*Build ECEC teacher option*/}
                {buildOptionItem(
                  ececImg,
                  "I'm an Early Childhood Educator",
                  4,
                  true // disabled
                )}
                {/*Build ELT teacher option*/}
                {buildOptionItem(
                  eltImg,
                  "I'm a qualified English Language Teacher",
                  1
                )}

                {/*Build VET teacher option*/}
                {buildOptionItem(
                  vetImg,
                  "I'm a qualified Vocational Education & Training Teacher or Digital/Tech Skills Teacher",
                  2
                )}

                {/*Build ELT&VET teacher option*/}
                {buildOptionItem(
                  eltVet,
                  "I'm qualified in both ELT and VET and wish to apply for roles in both sectors",
                  3
                )}
              </Item.Group>
            </div>
          </>
        )
      }
      <br />
      <div className="confirmButton-teacherOption">
        <ConfirmButton
          className="signup-button"
          onClick={step === 1 ? nextStep : gotoRegPage}
        >
          { step === 1 ? "Next" : "Submit"}
      </ConfirmButton>
      </div>
      <LinkToCreateAccount onRegister={true} />

      {isShowECECTeacherModal && <Modal
        show={showTeacherModal}
        onClose={() => setShowTeacherModal(false)}
        header="Important Notice"
        className="teacher-work-modal"
      >
        <div className="center-text">
          <p>
            Please note there is currently extremely limited work in Australia for English language teachers. 
            You are welcome to continue to your Profile setup and you will be contacted when work resumes. 
            Please check our job listings page for overseas opportunities.
          </p>
        </div>
        <div className="row mt-4">
          <div className="col-12">
            <ConfirmButton onClick={() => {
              setShowTeacherModal(false);
            }}>
              I understand
            </ConfirmButton>
          </div>
        </div>
      </Modal>}

    </SignupContainer>
  )
}

export default TeacherOption
